import { Moment } from "moment";
import { JobEstimationDetail } from "../../../modals/JobEstimationDetail";
require("./PickUpSummary.css");

interface PickUpSummaryProps {
  pickUpDate: Moment | null;
  pickUpTime: any;
  estimateDetails: JobEstimationDetail;
}

const PickUpSummary = (props: PickUpSummaryProps) => {
  return (
    <div className="m-4">
      <p>
        <b>Pick up date:</b> {props.pickUpDate?.format("DD-MM-YYYY")}
      </p>
      <p>
        <b>Pick up time:</b> {props.pickUpTime}
      </p>
    </div>
  );
};

export default PickUpSummary;
